import React from "react";
import ReactDOM from "react-dom";
// Templates
import Note from "./templates/Note";

export default function Yumetan() {
    const mainText = `
  動画内容とあわせて解説プリントをご確認ください。
  `;
    const textList = [
        {
            text: "●「単語の覚え方」プリント 初級編（ユメタンの使い方 動画用）",
            fileName: "単語の覚え方_初級編"
        }
    ];

    return <Note mainText={mainText} textList={textList} />;
}

if (document.getElementById("how_to_yumetan")) {
    ReactDOM.render(<Yumetan />, document.getElementById("how_to_yumetan"));
}
